import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityInvitationsSendPostAsyncSlice } from './post';

export const securityInvitationsSendReducers = combineReducers({
	post: securityInvitationsSendPostAsyncSlice.asyncReducers
});

export const securityInvitationsSendWatchers = combineAllWatchers([
	securityInvitationsSendPostAsyncSlice.asyncWatchers
]);
